export const NAVIGATION_STATUS = {
  INACTIVE: "0",
  ACTIVE: "1",
  REGISTER: "2",
  REGISTER_NOTCOMPLETE: "3"
};
